import React, { useState, useEffect } from 'react';

function LoadingDots() {
  const [dots, setDots] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((dots) => (dots + 1) % 5, 400);
    }, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <span>{dots === 0 ? '' : '.'.repeat(dots)}</span>
  );
}

export default LoadingDots;
